'use strict';

productOverviewItem.$inject = ["common"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productOverviewItem = productOverviewItem;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productOverviewItem(common) {
    // prodFactory and getClass are created to be able to use the ProductModel recursively
    var prodFactory = {
        getClass: function getClass() {
            var clazz = function ProductOverviewItem() {
                var defaults = {
                    id: null,
                    name: '',
                    discountName: '',
                    displayName: '',
                    type: '',
                    image: '',
                    sellerId: 0,
                    sellerName: '',
                    brand: '',
                    discountId: null,
                    discount: null,
                    productNumber: '',
                    promocode: '',
                    productNumberAndPromo: '',
                    price: 0,
                    time_remaining: null,
                    isInCart: false,
                    isSellableInStore: null,
                    isVipSeller: null,
                    portalContractTypeCode: null,
                    counterStatus: null,
                    counter: null,
                    grossProfit: undefined,
                    grossProfitAmount: 0,
                    // calculated totals and discount
                    highestDiscount: null,
                    lowestDiscount: null,
                    quantity: 0,
                    quantityToAddForHighestDiscount: 0,
                    unitPriceWithDiscount: 0,
                    totalPriceWithoutDiscount: 0,
                    totalDiscount: 0,
                    totalPriceWithDiscount: 0,
                    discountPct: 0,
                    other_discounts: [],
                    priority: 0,
                    // tmp
                    message: null,
                    activeDiscountIds: [],
                    totalPriceDiscountIds: [],
                    expirationDate: null
                };

                _lodash2.default.extend(this, defaults);
            };

            _lodash2.default.extend(clazz.prototype, {
                getInitialQuantity: function getInitialQuantity(cart) {
                    // when the product (with the correct discount) is in the cart, get the quantity from the cart
                    var quantityFromCart = 0;
                    if (cart) {
                        quantityFromCart = cart.getProductQuantity(this.id, this.discountId);
                        if (quantityFromCart > 0) {
                            return quantityFromCart;
                        }
                    }

                    var highestDiscount = this.getHighestDiscount();
                    return highestDiscount ? highestDiscount.amount : 1;
                },

                getQuantityToAddForHighestDiscount: function getQuantityToAddForHighestDiscount() {
                    if (!this.highestDiscount) {
                        return 0;
                    }

                    return this.highestDiscount.amount - this.quantity;
                },

                getDiscountPctForQuantity: function getDiscountPctForQuantity() {
                    // NOTE: for now, we assume that all discounts are percentages
                    if (!this.discount || !this.discount.ranges || this.discount.ranges.length <= 0) {
                        return 0;
                    }

                    // NOTE: discounts are sorted from high to low
                    for (var i = 0; i < this.discount.ranges.length; i++) {
                        var range = this.discount.ranges[i];
                        if (this.quantity >= range.amount) {
                            return range.discount;
                        }
                    }

                    return 0;
                },

                getHighestDiscount: function getHighestDiscount() {
                    if (!this.discount || !this.discount.ranges || this.discount.ranges.length <= 0) {
                        return null;
                    }

                    return this.discount.ranges[0];
                },

                getLowestDiscount: function getLowestDiscount() {
                    if (!this.discount || !this.discount.ranges || this.discount.ranges.length <= 0) {
                        return null;
                    }
                    return this.discount.ranges[this.discount.ranges.length - 1];
                },
                getCartCurrentDiscount: function getCartCurrentDiscount(cartProducts) {
                    var _this = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.id === _this.id;
                    });
                    return productSearch ? productSearch.discountPercentage : 0;
                },
                getCartCurrentDiscountPromoCode: function getCartCurrentDiscountPromoCode(cartProducts) {
                    var _this2 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.id === _this2.id;
                    });
                    return productSearch ? productSearch.discountPromoCode : null;
                },
                getTotalDiscount: function getTotalDiscount(cartProducts) {
                    var _this3 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.id === _this3.id;
                    });
                    return productSearch ? productSearch.discountAmount : null;
                },
                getCartFields: function getCartFields(product, shoppingCartProducts) {

                    //Find the product that has to updated in the list of products that are in the shoppingcart
                    var productToUpdate = shoppingCartProducts.find(function (shoppingCartProduct) {
                        if (product.nationalNumber && shoppingCartProduct.productNumber === product.nationalNumber) {
                            return shoppingCartProduct.productNumber === product.nationalNumber;
                        } else {
                            var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                return productWithPossibleDiscount.id === product.id;
                            });
                            return shoppingCartProductSearch ? true : false;
                        }
                    });

                    if (productToUpdate) {
                        product.discountPct = productToUpdate.discountPercentage;
                        product.grossProfit = productToUpdate.grossProfit * 100;
                        product.grossProfitAmount = productToUpdate.grossProfitAmount;
                        product.promocode = productToUpdate.discountPromoCode;
                        product.quantity = productToUpdate.amount;
                        product.totalDiscount = productToUpdate.discountAmount;

                        //clear the discountId's
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];

                        //add the new discount id's
                        productToUpdate.productWithPossibleDiscounts.map(function (discount) {
                            product.activeDiscountIds.push(discount.discountIds);
                            product.totalPriceDiscountIds.push(discount.totalPriceDiscountId);
                        });
                    } else {
                        product.quantity = 0;
                        product.discountPct = 0;
                        product.promocode = null;
                        product.activeDiscountId = 0;
                        product.totalPriceDiscountId = 0;
                        product.panaceeQuantity = 0;
                        product.grossProfit = 0;
                        product.grossProfitAmount = 0;
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];
                    }
                    //Return the updated product
                    return product;
                }
            });

            clazz.create = function (resource, cartProducts) {
                var product = new clazz();
                product.id = resource.productId;
                product.discountId = resource.discountId;
                // On discount pages, discount name should be used
                product.displayName = resource.discountName !== null && resource.discountName !== undefined ? resource.discountName : resource.productName;
                product.image = resource.imagePath;
                product.price = resource.pharmacyPrice;
                product.publicPrice = resource.publicPrice;
                product.netPublicPrice = resource.netPublicPrice;
                product.nationalNumber = resource.productNumber ? resource.productNumber : resource.nationalNumber;
                product.isSellableAsSingleProduct = resource.isSellableAsSingleProduct;
                product.isSellableInStore = resource.isSellableInStore;
                product.isVipSeller = resource.isVipSeller;
                product.isSellable = resource.isSellable;
                product.productCreationDate = resource.productCreationDate;
                product.counterStatus = resource.counterStatus;
                product.counter = resource.counter;
                product.portalContractTypeCode = resource.portalContractTypeCode;
                product.maxDiscount = resource.maxDiscount;
                product.tooLate = resource.tooLate;
                product.productTypeCode = common.serverTypes.getProductType(resource.productTypeCode);
                product.grossProfit = resource.grossProfit;
                product.grossProfitAmount = resource.grossProfitAmount;
                product.sellerName = resource.sellerName;
                product.allowSpecial = resource.allowSpecial;
                product.grossProfitAmount = resource.grossProfitAmount;
                product.expirationDate = resource.expirationDate;
                product.sellerId = resource.sellerId;
                //todo split in rental product
                product.dayPrice = resource.dayPrice;
                product.netPublicPrice = resource.netPublicPrice;
                product.publicPrice = resource.publicPrice;
                product.pharmacyPrice = resource.pharmacyPrice;
                product.rentalDeposit = resource.rentalDeposit;
                product.vat = resource.vat;
                product.imagePath = resource.imagePath;

                // Get fields from shoppingcart
                if (cartProducts) {
                    product = product.getCartFields(product, cartProducts);
                }
                return product;
            };

            return clazz;
        }
    };

    return prodFactory;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/productOverviewItemModel.js
// module id = 776
// module chunks = 0